import React, { Fragment, useEffect } from "react";
import { useState } from "react";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import "./style.css";
import ActiveEmployees from "./Active";
import { useLocation } from "react-router-dom";
import Resignation from "./Resignation";
import NoticePeriod from "./NoticePeriod";
import DeletedEmployees from "./Deleted";
import Salaries from "../Salaries";
import Vacations from "../Vacations";
import Deduction from "../Deduction";
import Provision from "./Provision";
import Sick from "../Sick";

const tabs = [
	{ label: "employees", icon: "users" },
	{ label: "salaries", icon: "money" },
	{ label: "vacations", icon: "umbrella" },
	{ label: "deduction", icon: "ban" },
	{ label: "provision", icon: "cube" },
	{ label: "sick_leave", icon: "truck" },
];
const employeesTabs = ["active", "termination"]; //"notice_period", "resignation",

const Employee = () => {
	const [selectTab, setSelectTab] = useState("employees");
	const [selectEmployeesTab, setSelectEmployeesTab] = useState("active");
	const lang = useSelector((state) => state.auth?.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const location = useLocation();

	useEffect(() => {
		if (!!location?.state) {
			if (location?.state === "resignation")
				setSelectEmployeesTab("resignation");
			if (location?.state === "vacations") setSelectTab("vacations");
		}
	}, [location]);

	return (
		<Fragment>
			<Card className="mb-3 py-3">
				<div className="custom-tabs-div">
					{tabs?.map((tab, index) => {
						return (
							<p
								key={index}
								className={`${tab.label === selectTab ? "activeP" : ""}`}
								onClick={() => setSelectTab(tab?.label)}>
								<i className={`fa fa-${tab?.icon}`} />{" "}
								{Translate[lang][tab.label]}
							</p>
						);
					})}
				</div>
			</Card>

			{selectTab === "employees" && (
				<>
					<Card className="mb-3 w-fit-content">
						<Card.Body className="p-0 w-fit-content">
							<div className="tabs-div">
								{employeesTabs?.map((tab, index) => {
									return (
										<p
											key={index}
											className={`${
												tab === selectEmployeesTab ? "activeP" : ""
											}`}
											onClick={() => setSelectEmployeesTab(tab)}>
											{Translate[lang][tab]}
										</p>
									);
								})}
							</div>
						</Card.Body>
					</Card>
					{selectEmployeesTab === "active" && <ActiveEmployees />}
					{selectEmployeesTab === "resignation" && <Resignation />}
					{selectEmployeesTab === "notice_period" && <NoticePeriod />}
					{selectEmployeesTab === "termination" && <DeletedEmployees />}
				</>
			)}
			{selectTab === "salaries" && <Salaries />}
			{selectTab === "vacations" && <Vacations />}
			{selectTab === "deduction" && <Deduction />}
			{selectTab === "provision" && <Provision />}
			{selectTab === "sick_leave" && <Sick />}
		</Fragment>
	);
};

export default Employee;
